<template>
<div  class="photoBox">
        <img
          v-for="(item, index) in photoUrls"
          :key="index"
          :src="item"
          :class="[photoselect === index ? 'active' : 'photoImg']"
          @click="imgphoto(index)"
        />
      </div>
</template>

<script>
export default {
  props: ['photoUrls'],
  data() {
    return {
        // 企业相册
      // 放大图片
      photoselect: "",
    };
  },
  methods:{
    // 公司相册选择放的图片
    imgphoto(index) {
      if (this.photoselect === index) {
        this.photoselect = "";
      } else {
        this.photoselect = index;
      }
    },
  }
};
</script>

<style lang="less" scoped>
// 企业相册
.photoBox {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  background-color: #104853;
}

.photoImg {
  width: 30%;
  height: 15vh;
  transform: scale(1); /*图片原始大小1倍*/
  transition: all ease 0.5s;
}
.photoImg:last-child:nth-child(3n - 1) {
  margin-right: calc(34.5%);
}
.photoImg:last-child:nth-child(3n - 2) {
  margin-right: calc(67.5%);
}
.active {
  transform: scale(1.5); /*图片需要放大3倍*/
  position: fixed;
  top: 50%;
  left: 0px;
  right: 0px;
  z-index: 100;
  width: 400px;
  height: 300px;
}
.photoBox img {
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.15) 0 0 8px;
  background: #fbfbfb;
  border: 1px solid #ddd;
  margin: 10px auto;
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/digital_industry/companyInformation/menu2.vue